const headers = [
    { text: 'Id', value: 'id' },
    { text: 'Tipo', value: 'note_model.tax_document_type' },
    { text: 'Status', value: 'status' },
    { text: 'Data da Venda', value: 'data_sale' },
    { text: 'Chave de Acesso', value: 'access_key' },
    { text: 'PDV', value: 'pdv.description' },
    { text: 'Série', value: 'series' },
    { text: 'Número da Nota', value: 'number_sale' },
    { text: 'Cliente', value: 'cliente.name' },
    { text: 'Vendedor', value: 'seller.people.physicalpeople.name' },
    { text: 'Valor da Nota', value: 'value_total_note' },
    { text: 'Ações', value: 'actions' }
];

export { headers };